import { css } from '@emotion/react'
import { HFlow, Text, Theme, useTheme } from 'bold-ui'
import { RiscoVulnerabilidadeIvcfEnum } from 'graphql/types.generated'
import { useMemo } from 'react'

import { IVCF_RESULTADOS } from '../model-ivcf'

interface IvcfResultadoLineProps {
  line: RiscoVulnerabilidadeIvcfEnum
}

export function IvcfResultadoLine(props: IvcfResultadoLineProps) {
  const { line } = props

  const theme = useTheme()
  const styles = useMemo(() => createStyles(theme), [theme])

  const lineDiv = createLine(props.line, styles)
  const lineTitle = IVCF_RESULTADOS[line].shortTitle
  const lineRange =
    line === RiscoVulnerabilidadeIvcfEnum.BAIXO
      ? '0-6'
      : line === RiscoVulnerabilidadeIvcfEnum.MODERADO
      ? '7-14'
      : '15-40'

  return (
    <div css={styles.div}>
      <HFlow css={styles.tableHeader}>
        <Text style={styles.tableHeaderPrimaryText}>{lineTitle}</Text>
        <Text style={styles.tableHeaderSecondaryText}>({lineRange})</Text>
      </HFlow>
      {lineDiv}
    </div>
  )
}

const createLine = (type: RiscoVulnerabilidadeIvcfEnum, styles) => {
  const styleMap = {
    [RiscoVulnerabilidadeIvcfEnum.BAIXO]: styles.lineBaixo,
    [RiscoVulnerabilidadeIvcfEnum.MODERADO]: styles.lineMedio,
    [RiscoVulnerabilidadeIvcfEnum.ALTO]: styles.lineAlto,
  }

  return <div css={[styles.line, styleMap[type]]} />
}

const createStyles = (theme: Theme) => ({
  div: css`
    padding: 0;
    margin: 0;
  `,
  tableHeader: css`
    display: flex;
    align-items: center;
    justify-content: center;
    grid-gap: 0.25rem;
    background: ${theme.pallete.gray.c90};
    height: 1.5rem;
    margin-bottom: 1.125rem;
  `,
  tableHeaderPrimaryText: css`
    color: ${theme.pallete.gray.c10};
  `,
  tableHeaderSecondaryText: css`
    color: ${theme.pallete.gray.c40};
  `,
  line: css`
    height: 0.25rem;
  `,
  lineBaixo: css`
    background: ${IVCF_RESULTADOS.BAIXO.lineBgColor};
  `,
  lineMedio: css`
    background: ${IVCF_RESULTADOS.MODERADO.lineBgColor};
  `,
  lineAlto: css`
    background: ${IVCF_RESULTADOS.ALTO.lineBgColor};
  `,
})
